/**
 * @generated SignedSource<<d37b602fa10a7e9c324404de54c54347>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsYourFirm_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsYourFirmMembers_viewer" | "TradeBenefitsYourFirmRep_viewer">;
  readonly " $fragmentType": "TradeBenefitsYourFirm_viewer";
};
export type TradeBenefitsYourFirm_viewer$key = {
  readonly " $data"?: TradeBenefitsYourFirm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsYourFirm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsYourFirm_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsYourFirmRep_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsYourFirmMembers_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bc683906cfbd91e4f26c477f4b3f2fc0";

export default node;
